import clsx from 'clsx';
import styles from './Toast.module.scss';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CalendarIcon } from '../../../../assets/svg/icons/calendario.svg';
import { getClientDisplayName } from '../utils/taskDisplay';

export const ToastSuccess = ({ booking, type = 'new' }) => {
  const { t } = useTranslation();
  const event = booking?.event || booking || {};

  const title = {
    new: t('scheduler.toast.newBooking'),
    update: t('scheduler.toast.updatedBooking'),
    delete: t('scheduler.toast.cancelledBooking'),
  };

  const datePart = event?.data_prenotazione?.split?.('T')?.[0];
  const [startHour = '0', startMinute = '0'] = (event?.orario_start || '00:00').split(':');
  const day = datePart
    ? dayjs(datePart).set('hour', Number(startHour)).set('minute', Number(startMinute))
    : dayjs();

  const resolvedName = getClientDisplayName(event);
  const name =
    resolvedName && !/^Utente\s*$/i.test(resolvedName)
      ? resolvedName
      : event?.self_prenotatione || event?.selfPrenotazione
        ? t('scheduler.toast.fromSalon')
        : resolvedName || t('scheduler.toast.fromSalon');

  const timeLabel = day.format('HH:mm');
  const dateLabel = day.format('D MMMM YYYY');

  return (
    <div className={clsx(styles.container_toast, styles[`container_toast_${type}`])}>
      <div className={styles.toast_header}>
        <span className={styles.toast_icon_wrap} aria-hidden="true">
          <CalendarIcon className={styles.toast_icon} />
        </span>
        <div className={styles.toast_text_block}>
          <p className={styles.toast_title}>{title[type] || title.new}</p>
          <p className={styles.toast_name}>{name}</p>
          <p className={styles.toast_meta}>
            <span className={styles.toast_time}>{timeLabel}</span>
            <span className={styles.toast_date}>{dateLabel}</span>
          </p>
        </div>
      </div>
    </div>
  );
};
